import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const label = {
  fontWeight: tokens.fontWeightBold,
  fontSize: tokens.fontSizeBase200,
  lineHeight: tokens.lineHeightBase300,
};

export const useHealthGoalHeaderStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...shorthands.padding(
      tokens.spacingVerticalL,
      tokens.spacingHorizontalXS,
      tokens.spacingVerticalS,
      tokens.spacingHorizontalL,
    ),
  },
  icon: {
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalMNudge,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  title: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase400,
  },
  completedIcon: {
    color: tokens.colorPaletteLightGreenForeground3,
  },
  rightSection: {
    alignSelf: 'flex-start',
  },
  statusText: {
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
  },
  completionLabel: {
    ...label,
    color: tokens.colorPaletteLightGreenForeground2,
  },
  recommendedLabel: {
    ...label,
  },
  endedStatus: {
    color: tokens.colorNeutralForegroundDisabled,
  },
});
